<template>
  <div class="container shape-container d-flex align-items-center mt-5 mb-5">
      <div class="col px-0">
    <div class="row justify-content-center align-items-center" >
      <div class="col-md-2 col-ms-12 selectCityLeadText">
    <p class="leads">Select City</p>
      </div>
      <div class="col-md-7 col-ms-12">
    <div class="countryselect-wrapper">
      <multiselect
        :multiple="true" 
        placeholder="Select atleast one city"
        v-model="cityvalue"
        :options="cityoptions"
      ></multiselect>
    </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: "CitySelect",
  components: {},
  data() {
    return {
      cityvalue: null,
      cityoptions: ["Mumbai", "Delhi", "Banglore"]
    };
  }
};
</script>

<style scoped>
.leads{
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.5;
  color: #000;
}
.countryselect-wrapper {
  border: 0px!important;
    border-bottom: 1px solid #000!important;
    
    
}
</style>